import * as angularServiceWorker from "@angular/service-worker";

// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};

window["ng"].serviceWorker = angularServiceWorker;

export { angularServiceWorker };
